<!-- Heading -->
<mdb-card class="mb-4 wow fadeIn">
  <mdb-card-body class="d-flex flex-wrap justify-content-between align-items-center p-2 m-2">
    <div class="md-form col-sm-12 col-md-2 col-lg-2 m-1">
      <input
        [(ngModel)]="transactionSearchRequest.searchTerm"
        mdbInput
        name="searchTerm"
        type="text"
        (keyup.enter)="SearchTrades()"
        id="searchTerm"
        class="form-control"
        #searchTerm="ngModel"
        required
      />
      <label for="searchTerm">Search</label>
    </div>
    <div class="md-form col-sm-12 col-md-2 col-lg-2 m-1">
      <select
        class="md-form form-control browser-default w-100"
        id="status"
        [(ngModel)]="transactionSearchRequest.transactionStatusId"
        placeholder="Status"
        (change)="SearchTrades()"
      >
        <option *ngFor="let status of filterStatuses" [ngValue]="status.id">
          {{ status.name }}
        </option>
      </select>
      <label for="status" class="active">Trade Status</label>
    </div>
    <div class="col-sm-12 col-md-2 col-lg-2 m-1">
      <mdb-checkbox class="browser-default w-100" checked="true" [(ngModel)]="transactionSearchRequest.todaysTradesOnly"
        >Today's Trades Only</mdb-checkbox
      >
    </div>
    <div *ngIf="this.badStatusCounts.length > 0" class="d-flex flex-column align-items-center col-sm-12 col-md-auto m-1">
      <div *ngFor="let bad of this.badStatusCounts">
        <mdb-badge [color]="getBadgeColorForStatus(bad.statusId)" class="mb-1">{{ bad.count }} {{ getStatusName(bad.statusId) }}</mdb-badge>
      </div>
    </div>
    <div class="col-sm-12 col-md-2 col-lg-2 text-right m-1">
      <button mdbBtn size="sm" class="btn-trakly-action" mdbWavesEffect (click)="SearchTrades()">Search</button>
    </div>
  </mdb-card-body>
</mdb-card>
<mdb-card cascade="true" narrower="true" class="mt-3">
  <div
    id="user-trades-sticky"
    class="sticky-top view view-cascade gradient-card-header blue-gradient narrower py-2 mx-4 mb-3 d-flex justify-content-between align-items-center"
  >
    <p class="white-text mx-3 my-auto">Current Trades</p>
    <div>
      <div class="col-12 text-center" *ngIf="downloadBusy">
        <span>Downloading...</span>
        <span class="spinner-grow text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </span>
      </div>
      <div *ngIf="!downloadBusy">
        <button
          type="button"
          mdbBtn
          color="white"
          outline="true"
          rounded="true"
          size="sm"
          class="px-2"
          mdbWavesEffect
          (click)="Extract('InProgressTransactions')"
        >
          <mdb-icon fas icon="cloud-download-alt" class="mt-0"></mdb-icon> Extract
        </button>
      </div>
    </div>
  </div>

  <div class="px-4">
    <div class="col">
      <div *ngIf="showError && !busy" class="alert alert-danger text-center font-weight-bold" role="alert">
        {{ errorMsg }}
      </div>
    </div>
    <div class="table-responsive" *ngIf="!busy" style="overflow: visible">
      <!--Table-->
      <table class="table table-sm" mdbTable hover="true" stickyHeader="true" id="InProgressTransactions">
        <thead>
          <tr>
            <th scope="col" class="text-left sortable" [appSort]="transactions" data-order="desc" data-name="fullName">Full Name</th>
            <th scope="col" class="text-center">Trade Amount</th>
            <th scope="col" class="text-center sortable" [appSort]="transactions" data-order="desc" data-name="transactionStatusId">
              Status
            </th>
            <th scope="col" class="text-center">Last Message</th>
            <th
              scope="col"
              class="text-center sortable"
              [appSort]="transactions"
              data-order="desc"
              data-name="transactionStartDate"
              data-type="date"
            >
              Created
            </th>
            <th
              scope="col"
              class="text-center sortable"
              [appSort]="transactions"
              data-order="desc"
              data-name="bookNowReceived"
              data-type="date"
            >
              Book Now Message
            </th>
            <th scope="col" class="text-center"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let trade of transactions">
            <td class="text-left middleCenter">
              <span mdbTooltip="{{ buildTradeInfoText(trade) }}" [html]="true">{{ trade.fullName }}</span>
            </td>
            <td class="text-center middleCenter">R {{ trade.amountSent | number }}</td>
            <td class="middleCenter" style="max-width: 250px">
              <span class="statusBlock d-flex align-items-center justify-content-center" [ngClass]="setVisualStatusClass(trade)">
                <span mdbTooltip="{{ GetHoverHelpText(trade.transactionStatusId) }}">{{
                  GetStatusDisplayName(trade.transactionStatusId)
                }}</span>
                <span
                  *ngIf="IsTradeEditable(trade)"
                  (click)="EditTransactionAndDeal(trade)"
                  class="clickable fas fa-pen-to-square actionIcon ml-2"
                  mdbTooltip="Edit Trade"
                ></span>
              </span>
            </td>
            <td class="text-center middleCenter" style="max-width: 250px; white-space: normal">
              <div *ngIf="dealHasLastMessage(trade)" class="small text-muted">
                {{ lastMessage }}
              </div>
            </td>
            <td class="text-center middleCenter">
              {{ formatDateWithDayCheck(trade.transactionStartDate) }}
            </td>
            <td class="text-center middleCenter">
              {{ formatDateWithDayCheck(trade.bookNowReceived) }}
            </td>
            <td class="middleCenter text-center">
              <span *ngIf="trade.updateSuccess">
                <mdb-icon fas icon="circle-check" class="success-indicator"></mdb-icon>
              </span>
              <span *ngIf="trade.error">
                <mdb-icon fas icon="circle-xmark" class="success-indicator" (click)="popupError(trade.error)"></mdb-icon>
              </span>
            </td>
          </tr>
          <tr *ngIf="transactions.length === 0">
            <td colspan="7" class="text-center text-muted py-4">Nothing found</td>
          </tr>
        </tbody>
      </table>
      <!--Table-->
    </div>
  </div>
  <!--Loading-->
  <div class="col-12 text-center" *ngIf="busy">
    <div *ngIf="busy" class="spinner-grow text-primary" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</mdb-card>

<app-trade-edit
  [(showModal)]="showTradeEditModal"
  [(transaction)]="selectedTransaction"
  [(deal)]="selectedTransactionDeal"
  [(status)]="selectedTransactionStatus"
  [(fullStatusList)]="transactionStatuses"
  (onModelChange)="updateOriginalTrade($event)"
  (onError)="handleModalError($event)"
></app-trade-edit>

<error-component [error]="errorResponse" [(showModal)]="showModalError"></error-component>
